// True when a position's value should be read from the user's on-chain
// USDv balance rather than the backend's `position.amount`. The 2026-05
// retail-pool collapse made retail positions TREASURY-type — they're
// claims on the user's own USDv balance, not a separately-tracked
// custodial amount. Until the backend ships an on-chain → off-chain
// balance sync, `position.amount` stays at "0" for fresh retail
// enrollments, so we overlay the SPL balance from useTokenBalancesData.
// The "Wallet" branch covers any pre-migration positions still in the
// wild for the same reason.
export function isRetailSelfHeldPosition(pool: { type: string }): boolean {
    return pool.type === "Treasury" || pool.type === "Wallet";
}
